import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=713a5b8e"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=713a5b8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports